var bind = { vm: '=' };
var FilterController = (function () {
    function FilterController($scope, socket, $state, env, $mdDialog, Dialog) {
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.env = env;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.profileName = 'Default profile';
    }
    FilterController.prototype.closeFilter = function () {
        this.vm.isFilterToggled = false;
    };
    FilterController.prototype.viewProfiles = function (ev) {
        this.Dialog.openDialog2(ev, '', FilterController, 'profiles.dialog.html', '', this.$scope);
    };
    FilterController.prototype.cancel = function (ev) {
        this.$mdDialog.cancel();
    };
    FilterController.$inject = ['$scope', 'socket', '$state', 'env', '$mdDialog', 'Dialog'];
    return FilterController;
}());
var FilterComponent = (function () {
    function FilterComponent() {
        this.bindings = bind;
        this.templateUrl = 'filter.html';
        this.controller = FilterController;
    }
    return FilterComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('filterSection', new FilterComponent());

//# sourceMappingURL=filter.component.js.map
